<template>
  <nav>
    <v-card class="pl-3 pr-3 pb-3 card2">
      <v-card-title>
        <h2 class="headline font-weight-light">Post</h2>
        <v-spacer />
        <v-btn flat color="error" @click="deletePost" round>
          <v-icon small>fa fa-trash</v-icon>&nbsp; Delete
        </v-btn>
      </v-card-title>
      <v-divider />
      <center>
        <div class="p1 pt-3">
          <span>From:</span>
          <span class="green--text font-weight-bold">&nbsp;{{source}}</span>
          <br />
          <span>To:</span>
          <span class="green--text font-weight-bold">&nbsp;{{destination}}</span>

          <br />
          <span>Date:</span>
          <span class="green--text font-weight-bold">&nbsp;{{date}}</span>
          <span>&nbsp; Time:</span>
          <span class="green--text font-weight-bold">&nbsp;{{time}}</span>
          <br />
          <span>Cab Booked:</span>
          <span class="green--text font-weight-bold">&nbsp;{{ cab_booked ? "Yes" : "No" }}</span>
          <br />
          <span>Co-passengers:</span>
          <span class="green--text font-weight-bold">&nbsp;{{accepted_count}}/{{accept_limit}}</span>
          <br />
          <br />
        </div>
      </center>
      <v-tabs
        slider-color="success"
        grow
        color="grey lighten-3"
        style="border-radius: 10px 10px 0px 0px;"
      >
        <v-tab ripple>Accepted</v-tab>
        <v-tab-item>
          <v-card
            flat
            max-height="236"
            min-height="236"
            color="grey lighten-4"
            class="card3 scroll pa-2"
          >
            <center><span v-if="accepted.length==0" style="font-size: 16px">You have no accepted requests.</span></center>
            <AcceptedBar
              v-for="user in accepted"
              :user="user"
              :key="user.uid"
            />
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </nav>
</template>

<script>
import firebase from "firebase";
import AcceptedBar from "@/components/AcceptedBar.vue";
export default {
	components: {
		AcceptedBar
	},
  props: {
    source: String,
    destination: String,
    cab_booked: Boolean,
    date: String,
    time: String,
    accept_limit: Number,
    accepted_count: Number,
    posted_by: Object,
    postId: String,
    accepted: Array,
    requests: Array
  },

  data() {
    return {

    };
  },

  methods: {
    deletePost(){
      const db=firebase.firestore();
      var vm=this;
      var index,index1,index2;
      var accepted=[];
      var requested=[];
      var rejected=[];
      var postDoc = null;
      db.collection('posts').doc(vm.postId).get()
      .then(function(doc){
        postDoc = doc;
        postDoc.data().accepted.forEach(function(obj){
          db.collection('users').doc(obj.uid).get()
          .then(function(snap){
            accepted = snap.data().accepted;
            index=accepted.indexOf(vm.postId);
            accepted.splice(index,1);
            db.collection('users').doc(obj.uid).update({
              accepted : accepted
            })
          })
        })
        postDoc.data().requests.forEach(function(obj1){
          db.collection('users').doc(obj1.uid).get()
          .then(function(snap1){
            requested = snap1.data().requested;
            index1=requested.indexOf(vm.postId);
            requested.splice(index1,1);
            db.collection('users').doc(obj1.uid).update({
              requested : requested
            })
          })
        })
        postDoc.data().rejected.forEach(function(obj2){
          db.collection('users').doc(obj2).get()
          .then(function(snap2){
            rejected = snap2.data().rejected;
            index2=rejected.indexOf(vm.postId);
            rejected.splice(index2,1);
            db.collection('users').doc(obj2).update({
              rejected : rejected
            })
          })
        })
        db.collection('posts').doc(vm.postId).delete()
      })
    }
  },

  computed: {

  }
};
</script>

<style scoped>
.card2 {
  border-radius: 10px;
}
.card3 {
  border-radius: 0px 0px 10px 10px;
}
.scroll {
  overflow-y: auto;
}
.card4 {
  border-radius: 10px 10px 0px 0px;
}
</style>
